import {hitGoogleTagManager} from "./hit_google_tag_manager";

export const gtmEventConstructionPhotosRegister = () => {
    hitGoogleTagManager({
        event: "GAEvent",
        GAEventCategory: "ui",
        GAEventAction: "rejestracja",
        GAEventLabel: "construction_photos",
        GAEventNoInteraction: true
    });
};
import {hitGoogleTagManager} from "./hit_google_tag_manager";

export const gtmEventConstructionPhotosRegister = () => {
    hitGoogleTagManager({
        event: "GAEvent",
        GAEventCategory: "ui",
        GAEventAction: "rejestracja",
        GAEventLabel: "construction_photos",
        GAEventNoInteraction: true
    });
};
